import {useEffect, useState} from 'react'
import { DirectionService } from '../../api/directionService'
import { useDispatch, useSelector } from 'react-redux'
import { contractService } from '../../api/contractService'
import classes from './ContractInfo.module.scss'
import { hideContract } from '../../store/reducers/ContractReducer/ContractReducer'
import classNames from 'classnames'

const ContractInfo = () => {

    const [hospitalName, setHospitalName] = useState('Інформація про договір')
    const [addInfo, setAddInfo] = useState()
    const [show,setShow] = useState(false)
    const [hospitalData, setHospitalData] = useState()
    const id = useSelector(state=>state.ContractSlice)
    const dispatch = useDispatch()

    const formatedDate = (date) =>{
        return new Date(date).toLocaleDateString('uk-UA', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
    }

    useEffect(()=>{
        if(id.show){
            HospitalValue(id.id)
        } 
    },[id])

    useEffect(()=>{
        if(hospitalData !== undefined && addInfo !== undefined){
            setShow(true)
        }
    },[hospitalData, addInfo])


    const HospitalValue = async(id) =>{
        await contractService.getContract(id).then(data=>{
            if(data){
                setHospitalData(data.data)
            }
        DirectionService.getOptions().then(res=>{
        if(res?.data){
            res.data.hospitals.map(el=>{
                if(el.id === data.data.hospitalId){
                    console.log(el)
                    setHospitalName(el.name)
                    setAddInfo({
                        "edrpou": el.edrpou,
                        "city": el.city,
                        "medicalDirector": el.medicalDirector,
                        "attendingDoctors": el.attendingDoctors,
                        "departments": el.departments
                    })
                }
            })
        }
        
        })
        })
    }

    const statusHandler = (status) =>{
        if (status === 'active'){
            return 'Дійсний'
        } else if (status === 'expired'){
            return 'Закінчився термін дії'
        } else if (status === 'cancelled'){
            return 'Скасований'
        } else if (status === 'finished'){
            return 'Завершений'
        }
    }

    const onClose = () =>{
         dispatch(hideContract())
    }

  return (
    <div className={classes.container}>
        <button onClick={onClose} className={classes.closeButton}>
            X
        </button>   
        <h2 className={classes.container__title}>{hospitalName}</h2>
        {show && <div className={classes.table}>
            <div className={classes.table__header}>
                <p>{hospitalData.name}</p>
                <p>{hospitalData.number}</p>
                <p>Від:{formatedDate(hospitalData.signedAt)}</p>
            </div>
            <div className={classes.table__dates}>
                <p>ЕДРПОУ:{addInfo.edrpou}</p>
                <p>Місто:{addInfo.city}</p>
            </div>
            {addInfo.medicalDirector !== null && <div className={classes.table__dates}>
                <p>Директор установи:{addInfo.medicalDirector}</p>
            </div>}
            <div className={classes.table__lists}>
                <div className={classes.table__main}>
                    <h3>Лікарі:</h3>
                    <p>{addInfo.attendingDoctors.length > 0 && addInfo.attendingDoctors.map(el=><p>{el}</p>)}</p>
                </div>
                <div className={classes.table__secondary}>
                    <h3>Відділення:</h3>
                    <p>{addInfo.departments.length > 0 && addInfo.departments.map(el=><p>{el.name}</p>)}</p>
                </div>
            </div>
            <div className={classes.table__dates}>
                <p>Дійсний від:{formatedDate(hospitalData.startDate)}</p>
                <p>Дійсний до:{formatedDate(hospitalData.endDate)}</p>
            </div>
            <div className={classes.table__lists}>
                <div className={classes.table__main}>
                    <h3>Основні дослідження</h3>
                    {hospitalData.agreements && [
                    ...hospitalData.agreements.filter(el => Object.keys(el)[0] === 'Гістологія'),
                    ...hospitalData.agreements.filter(el => Object.keys(el)[0] !== 'Гістологія')
                    ].map(el => {
                        return (
                            Object.keys(el)[0] !== 'Гістологія' &&
                                <div className={classes.table__box} key={Object.keys(el)[0]}>
                                    <p>Вид дослідження: {Object.keys(el)[0]}</p>
                                    <p>Загальна кількість:{el[Object.keys(el)[0]].quantity}</p>
                                    <p>Використані дослідження:{el[Object.keys(el)[0]].usedCount}</p>
                                    <p>Залишок:{(el[Object.keys(el)[0]].quantity-el[Object.keys(el)[0]].usedCount)}</p>
                                </div>
                            || Object.keys(el)[0] == 'Гістологія' &&
                                <div className={classes.table__box} key={Object.keys(el)[0]}>
                                    <p>Вид дослідження: {Object.keys(el)[0]}</p>
                                    <p>Загальна кількість:{el[Object.keys(el)[0]].quantity}</p>
                                    <p>Використані дослідження:{el[Object.keys(el)[0]].usedCount}</p>
                                    <p>Загальний залишок:{(el[Object.keys(el)[0]].quantity-el[Object.keys(el)[0]].usedCount)}</p>
                                    <div className={classes.category}>
                                    <h4>Категорія складності:</h4>
                                    <div className={classes.levels}>
                                        {[1, 2, 3, 4, 5].map((i) => (
                                        <div
                                            key={i}
                                            className={classNames(classes.level__group, {
                                            [classes.centered]: i === 5, // окремий стиль для центру
                                            })}
                                        >
                                            <p className={classes.level}>Категорія {i}:</p>
                                            <p className={classes.level__info}>Кількість: {el[Object.keys(el)[0]].complexity[i].quantity}</p>
                                            <p className={classes.level__info}>Використано: {el[Object.keys(el)[0]].complexity[i].usedCount}</p>
                                            <p className={classes.level__info}>Залишок: {el[Object.keys(el)[0]].complexity[i].quantity-el[Object.keys(el)[0]].complexity[i].usedCount}</p>
                                        </div>
                                        ))}
                                    </div>
                                    </div>
                                </div>
                        );
                    })}
                </div>
                <div className={classes.table__secondary}>
                    <h3>Додаткові дослідження</h3>
                    {hospitalData.additionalAgreements && [
                    ...hospitalData.additionalAgreements.filter(el => Object.keys(el)[0] === 'Гістологія'),
                    ...hospitalData.additionalAgreements.filter(el => Object.keys(el)[0] !== 'Гістологія')
                    ].map(el => {
                        return (
                            Object.keys(el)[0] !== 'Гістологія' &&
                                <div className={classes.table__box} key={Object.keys(el)[0]}>
                                    <p>Вид дослідження: {Object.keys(el)[0]}</p>
                                    <p>Загальна кількість:{el[Object.keys(el)[0]].quantity}</p>
                                    <p>Використані дослідження:{el[Object.keys(el)[0]].usedCount}</p>
                                    <p>Залишок:{(el[Object.keys(el)[0]].quantity-el[Object.keys(el)[0]].usedCount)}</p>
                                </div>
                            || Object.keys(el)[0] == 'Гістологія' &&
                                <div className={classes.table__box} key={Object.keys(el)[0]}>
                                    <p>Вид дослідження: {Object.keys(el)[0]}</p>
                                    <p>Загальна кількість:{el[Object.keys(el)[0]].quantity}</p>
                                    <p>Використані дослідження:{el[Object.keys(el)[0]].usedCount}</p>
                                    <p>Загальний залишок:{(el[Object.keys(el)[0]].quantity-el[Object.keys(el)[0]].usedCount)}</p>
                                    <div className={classes.category}>
                                    <h4>Категорія складності:</h4>
                                    <div className={classes.levels}>
                                        {[1, 2, 3, 4, 5].map((i) => (
                                        <div
                                            key={i}
                                            className={classNames(classes.level__group, {
                                            [classes.centered]: i === 5, // окремий стиль для центру
                                            })}
                                        >
                                            <p className={classes.level}>Категорія {i}:</p>
                                            <p className={classes.level__info}>Кількість: {el[Object.keys(el)[0]].complexity[i].quantity}</p>
                                            <p className={classes.level__info}>Використано: {el[Object.keys(el)[0]].complexity[i].usedCount}</p>
                                            <p className={classes.level__info}>Залишок: {el[Object.keys(el)[0]].complexity[i].quantity-el[Object.keys(el)[0]].complexity[i].usedCount}</p>
                                        </div>
                                        ))}
                                    </div>
                                    </div>
                                </div>
                        );
                    })}
                </div>
            </div>
            <p className={classes.table__status}>{statusHandler(hospitalData.status)}</p>
        </div>}
    </div>
  )
}

export default ContractInfo